import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NotificationPartial } from '@models/notification/notification';
import { NotificationService } from '@modules/notification/services/notification.service';
import { HttpParams } from '@angular/common/http';
import { PartialParams, Partial } from '@models/partial';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseComponent } from '@app/base/basecomponent';
import { NotificationModalData } from '@models/misc/modaldata';
import { Observable, timer } from 'rxjs';
import { delay, retryWhen, switchMap, take, takeUntil, tap, finalize, share } from 'rxjs/operators';
import { NotificationModalComponent } from '../notification-modal/notification-modal.component';


@Component({
  selector: 'notification-list',
  templateUrl: './notification-list.component.html'
})
export class NotificationList extends BaseComponent implements OnInit {

  @Input() unread: boolean;
  @Input() unreadCount: number;

  @ViewChild('notificationList', { static: false }) public notificationList: ElementRef<any>;

  public notifications: Array<NotificationPartial> = [];
  public hasMore: boolean;
  public loading: boolean = false;
  public modalOpen: boolean;
  private modalRef: BsModalRef;

  private partialParams = new PartialParams();
  private partSize: number = 5;
  // private offset: number = 0;

  public stream: Observable<number>;

  constructor(
    private notificationService: NotificationService,
    private modalService: BsModalService
  ) {
    super();
  }

  ngOnInit() {
    this.partialParams.partSize = this.partSize;

    this.initPolling();
  }

  initPolling() {
    // todo timerin aika haetaan järjestelmäasetuksista
    let polling = timer(1, 900000).pipe(
      takeUntil(this.cancelHttp),
      switchMap(() => this.notificationService.getUnreadCount().pipe(
        tap((val: number) => this.unreadCount = val),
        retryWhen(errors => {
          return errors.pipe(
            delay(2000),
            take(2),
            finalize(() => this.unreadCount = null)
          )
        })
      )),
      share()
    );

    this.subscription.add(polling.subscribe());
  }

  getPartialNotifications() {

    let queryParams = this.getQueryParams();

    this.loading = true;

    this.notificationService.getPartialNotifications(queryParams).subscribe(data => {
      this.loading = false;

      if (data.items == null) {
        this.hasMore = false;
        return;
      }
      
      this.processData(data);
      
      // data.items?.length > 0 ? this.hasMore = true : this.hasMore = false;
      // Adjusted this hasMore-thingy because it was showing the button for fetching more almost all the time
      data.items?.length === this.partialParams.partSize ? this.hasMore = true : this.hasMore = false;
      this.partialParams.part = ++data.part;

      setTimeout(() => {
        this.notificationList.nativeElement.scrollTop = this.notificationList.nativeElement.scrollHeight;
      });

    }, error => {
      this.loading = false;
      this.errorHandler.applyGeneralErrors(error);
    });
  }

  getQueryParams(): HttpParams {
    let queryParams = new HttpParams();

    //Partial
    if (this.partialParams.partSize) {
      queryParams = queryParams.set("partSize", String(this.partialParams.partSize));
    }

    queryParams = queryParams.set("part", String(this.partialParams.part));
    queryParams = queryParams.set("offset", String(this.partialParams.offset));
    queryParams = queryParams.set("lang", this.translate.currentLang);

    return queryParams;
  }

  processData(data: Partial<NotificationPartial>) {
    const newNotifications = data.items.filter(i => !this.notifications.some(n => n.id === i.id));
    this.notifications = this.notifications.concat(data.items);
  }

  markRead(notification: NotificationPartial) {
    this.notificationService.markRead(notification.id).subscribe(data => {
      notification.readTime = data;
      this.partialParams.offset--;
      this.unreadCount--;
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
    });
  }

  markAllRead() {
    this.notificationService.markAllRead().subscribe(data => {
      this.notifications.map(notification => {
        if (!notification.readTime) {
          notification.readTime = data;
          // this.offset++;
          // this.partialParams.offset++;
        }

      });
      this.unreadCount = 0;
      //this.hasMore = false;
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
    });
  }

  markCleared(notification: NotificationPartial) {
    this.notificationService.clearNotification(notification.id).subscribe(() => {
      const index = this.notifications.findIndex(n => n === notification);
      if (index >= 0)
        this.notifications.splice(index, 1);
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
    })
  }

  markAllCleared() {
    this.notificationService.clearAllNotifications().subscribe(() => {
      this.notifications = [];
    }, error => {
      this.errorHandler.applyGeneralErrors(error);
    });
  }

  viewNotification(notification: NotificationPartial) {
    this.modalOpen = true;

    const content: NotificationModalData = {
      title: notification.title,
      body: notification.message,
      confirmButtonText: notification?.readTime ? this.translate.instant('common.actions.close') : this.translate.instant('notification.mark_read'),
      confirmButtonClass: notification?.readTime ? 'btn btn-secondary' : 'btn btn-primary',
      critical: notification.critical,
      referenceType: notification.notificationReferenceType,
      referenceId: notification.notificationReferenceId
    };
    

    //const content: ModalData = {
    //  title: notification.title,
    //  body: notification.message,
    //  confirmButtonText: notification?.readTime ? this.translate.instant('common.actions.close') : this.translate.instant('notification.mark_read'),
    //  confirmButtonClass: notification?.readTime ? 'btn btn-secondary' : 'btn btn-primary'
    //};
    this.modalRef = this.modalService.show(NotificationModalComponent, { initialState: { data: content } });
    
    this.modalRef.content.onButtonClick.subscribe(() => {
      this.notificationService.markRead(notification.id).subscribe(data => {
        if (data) {
          notification.readTime = data;
          this.unreadCount--;
        }
      }, error => {
        this.errorHandler.applyGeneralErrors(error);
      });
    })

    this.modalRef.onHidden.subscribe(() => {
      this.modalOpen = false;
    });
  }

  getUnread() {
    this.notificationService.getUnreadCount().subscribe(data => {
      this.unreadCount = data;
    }, error => {
      // Should we ignore error messages here?
      // this.errorHandler.applyGeneralErrors(error);
      this.unreadCount = null;
    });
  }

  emptyList() {
    this.notifications = [];
    this.partialParams.part = 1;
    this.partialParams.offset = 0;
    // this.offset = 0;
  }

  populateList() {
    this.getUnread();
    this.getPartialNotifications();
  }

  // allNotificationsRead(): boolean {
  //   return this.notifications.every(notification => notification?.viewed.readTime);
  // }
}

